import React, {useEffect, useState} from 'react';
import {Select} from "antd";
import {GroupSelectOption} from "./GroupSelect2.interface";
import Constants from "../../../../constants";

interface GroupSelect2Props {
	value?: string;
	groupData: any[];
	onSelect: (value: string, option: GroupSelectOption | GroupSelectOption[]) => void;
}

const GroupSelect2 = ({ value, groupData, onSelect }: GroupSelect2Props) => {
	const [groupOptions, setGroupOptions] = useState<GroupSelectOption[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		const newGroupOptions = groupData.map((group) => ({
			value: group.id,
			label: group.name,
		}));
		setGroupOptions(newGroupOptions);
		setLoading(false);
	}, [value, groupData]);


	const handleChange = (value: string, option: GroupSelectOption | GroupSelectOption[]) => {
		onSelect(value, option);
	};

	const resolvedValue = groupOptions.some(opt => opt.value === value)
		? value
		: undefined;

	return (
		<Select
			value={resolvedValue}
			showSearch
			loading={loading}
			placeholder="배차방 선택"
			options={groupOptions}
			onChange={handleChange}
			optionFilterProp="label"
			filterOption={(input, option) =>
				(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
			}
			filterSort={(a, b) => {
				if (a.value === Constants.CALL_CENTER_GROUP_ID) return -1;
				if (b.value === Constants.CALL_CENTER_GROUP_ID) return 1;
				return a.label.localeCompare(b.label, 'ko');
			}}
		/>
	);
};

export default GroupSelect2;
